import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink } from 'react-router-dom';
import { useState } from 'react';
import { Button, Container, FormControl, Select, IconButton, InputLabel, Link, MenuItem, Popover, Stack, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Grid, TextField, Tooltip } from '@mui/material'
// components
import Iconify from '../components/iconify/Iconify';
// sections
import { getInspectionWorkOrderList, fetchinspectordetails, actionInspectionList } from './qualityApi';
import loader from '../../images/loader.gif';
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { Add as AddIcon } from '@mui/icons-material';
import { Box } from '@mui/material'
import { getLocalStorageItem } from '../../common/localStorageUtils';
import jwt from 'jwt-decode';
import { Close } from '@mui/icons-material';
import { format } from "date-fns";
import { QUALITY_ROLES } from '../../common/constants';
import { fDate } from '../../common/common-sidebar/utils/formatTime';
import { AssignIcon, EditIcon } from '../../common/icons';

function WorkInspectionOrder() {
  const navigate = useNavigate();
  const loggedInEmail = jwt(getLocalStorageItem('id_token')).emails?.[0]
  const [open, setOpen] = useState(null);
  const [openAssign, setOpenAssign] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [allinspectionworklist, setAllInspectionWorkList] = useState([]);
  const [selectedRowForAction, setSelectedRowForAction] = useState();
  // const [isLoading, setLoading] = useState(true);
  const [inspectionAssignDetails, setInspectionAssign] = useState({
    orderId: '',
    qualityParameter: '',
    qualityParamId: '',
    qualityParamTableId: '',
    dateOfInspection: '',
    locationType: '',
    storageLocation: '',
    materialCode: '',
    status: '',
    inspectorName: '',
    inspectorEmail: '',
    inspectorContact: '',
    inspectDescription: '',
    categoryOfInspection: '',
    inspectionEquipmentUsed: '',
    lotNumber: '',
    triggeringReason: '',
    surprise: '',
    measuredQuantity: '',
    actualQuantity: '',
    createdBy: '',
    inspectorpresent: '',
    requesterName: '',
    createdDate: '',
    createdOn: '',
    grievenceNumber: ''

  });
  const [inspectorDetails, setInspectorDetails] = useState([]);
  const [quaParaArray, setQuaParaArray] = useState([]);
  const [selectedInspectorDetails, setSelectedInspectorDetails] = useState([]);
  useEffect(() => {
    getInspectionWorkOrderList(setAllInspectionWorkList)
  }, []);
  useEffect(() => {
    if (selectedInspectorDetails?.statusCde === '100') {
      getInspectionWorkOrderList(setAllInspectionWorkList)
      setInspectionAssign([]);
      setQuaParaArray();
      setInspectorDetails([])
    }
  }, [selectedInspectorDetails]);

  const handleOpenMenu = (event, orderid, worklistquality) => {
    setOpen(event.currentTarget);
    setOpenId(orderid)
    setInspectionAssign({
      ...inspectionAssignDetails,
      id: worklistquality?.id,
      orderId: selectedRowForAction.inspectionOrderId,
      qualityParameter: worklistquality?.parameterResponsePojo?.map(i => i?.quaParameter).join(', '),
      dateOfInspection: worklistquality?.dateOfInspection,
      locationType: worklistquality?.inspectionLocationType,
      storageLocation: worklistquality?.inspectionStorageLocation,
      materialCode: worklistquality?.materialCode,
      status: worklistquality?.status,
      inspectDescription: worklistquality?.inspectDescription,
      categoryOfInspection: worklistquality?.categoryOfInspection,
      inspectionEquipmentUsed: worklistquality?.inspectionEquipmentUsed,
      lotNumber: worklistquality?.lotNumber,
      triggeringReason: worklistquality?.triggeringReason,
      surprise: worklistquality?.surprise,
      measuredQuantity: worklistquality?.measuredQuantity,
      actualQuantity: worklistquality?.actualQuantity,
      createdBy: worklistquality?.createdBy,
      inspectorName: worklistquality?.inspectorName,
      inspectorEmail: worklistquality?.inspectorEmail,
      inspectorContact: worklistquality?.inspectorContactNo,
      inspectorpresent: worklistquality?.inspectorName ? "yes" : "no",
      requesterName: worklistquality?.requesterName,
      createdDate: worklistquality?.createdDate,
      createdOn: worklistquality?.createdOn,
      grievenceNumber: worklistquality?.grievenceNumber
    })
    setQuaParaArray(worklistquality?.bundleIdEntity)
    fetchinspectordetails(setInspectorDetails)
  };
  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
    setOpenAssign(null);
  };
  console.log("inspectionAssignDetails", inspectionAssignDetails)
  function assignInspection(e, row) {
    setOpenAssign(e.currentTarget);
    setInspectionAssign({
      ...inspectionAssignDetails,
      id: row?.id,
      orderId: row?.inspectionOrderId,
      qualityParameter: row?.parameterResponsePojo?.map(i => i?.quaParameter).join(', '),
      dateOfInspection: row?.dateOfInspection,
      locationType: row?.inspectionLocationType,
      storageLocation: row?.inspectionStorageLocation,
      materialCode: row?.materialCode,
      status: row?.status,
      inspectDescription: row?.inspectDescription,
      categoryOfInspection: row?.categoryOfInspection,
      inspectionEquipmentUsed: row?.inspectionEquipmentUsed,
      lotNumber: row?.lotNumber,
      triggeringReason: row?.triggeringReason,
      surprise: row?.surprise,
      measuredQuantity: row?.measuredQuantity,
      actualQuantity: row?.actualQuantity,
      createdBy: row?.createdBy,
      inspectorName: row?.inspectorName,
      inspectorEmail: row?.inspectorEmail,
      inspectorContact: row?.inspectorContactNo,
      inspectorpresent: row?.inspectorName ? "yes" : "no",
      requesterName: row?.requesterName,
      createdDate: row?.createdDate,
      createdOn: row?.createdOn,
      grievenceNumber: row?.grievenceNumber
    })
    setQuaParaArray(row?.bundleIdEntity)
    fetchinspectordetails(setInspectorDetails)
  }
  function closeInspection(e) {
    setOpen(null);
    setInspectionAssign({ ...inspectionAssignDetails, status: '' })
    actionInspectionList(inspectionAssignDetails, 'Closed', quaParaArray, setSelectedInspectorDetails, navigate)
  }
  const handleChange = (e) => {
    let result_details = e.target.value.split("*")
    setInspectionAssign({ ...inspectionAssignDetails, inspectorName: result_details[0], inspectorEmail: result_details[1], inspectorContact: result_details[2] })
  }
  const onSubmitEditInspection = () => {
    actionInspectionList(inspectionAssignDetails, inspectionAssignDetails?.status, quaParaArray, setSelectedInspectorDetails, navigate)
  }
  const columns = [
    {
      field: 'inspectionOrderId', headerName: 'Inspection order ID', width: 150, sortable: false,
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }}>
            <Link onClick={() => { navigate(`conductinspectionwork`, { state: { inspectionOrderId: params?.row?.inspectionOrderId } }) }}>{params?.row?.inspectionOrderId}</Link>
          </div>
        )
      }
    },
    { field: 'inspectDescription', headerName: 'Subject', width: 200 },
    { field: 'categoryOfInspection', headerName: 'Category of Inspection', width: 150 },
    { field: 'createdBy', headerName: 'Requester Name', width: 230 },
    { field: 'inspectorName', headerName: 'Inspector', width: 150 },
    { field: 'inspectionEquipmentUsed', headerName: 'Inspection Equipment Used', width: 250 },
    {
      field: 'createdOn', headerName: 'Created Date', width: 150,
      renderCell: (params) => {
        return (
          <div>{fDate(params?.row?.createdOn, 'dd/MM/yyyy')}</div>
        )
      }
    },
    { field: 'status', headerName: 'Status', width: 150 },
    {
      field: 'dateOfInspection', headerName: 'Date of Inspection', width: 150,
      renderCell: (params) => {
        return (
          <div>{fDate(params?.row?.dateOfInspection, 'dd/MM/yyyy')}</div>
        )
      }
    },
    { field: 'inspectionLocationType', headerName: 'Inspection Location Type', width: 150 },
    { field: 'inspectionStorageLocation', headerName: 'Inspection Location(Storage location)', width: 150 },
    {
      field: 'surprise', headerName: 'Surprise', width: 100,
      renderCell: (params) => {
        return (
          <div>{(params?.row?.surprise === true) ? "Yes" : "No"}</div>
        )

      }
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 100,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Edit">
              <IconButton size="large" color="primary" onClick={() => { setSelectedRowForAction(params.row); navigate(`editinspectionwork/${params?.row?.inspectionOrderId}`) }}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            {console.log("inspectorpresent", inspectionAssignDetails)}
            {
              params.row.inspectorName ?
                <></>
                :
                <Tooltip title="Assign">
                  <IconButton size="large" color="primary" onClick={(e) => { assignInspection(e, params.row) }}>
                    <AssignIcon />
                  </IconButton>
                </Tooltip>


            }
          </>
          // <div className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }}>
          //   <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, params?.row?.inspectionOrderId, params?.row)}>
          //     <Iconify icon={'eva:more-vertical-fill'} />
          //   </IconButton>
          // </div>
        );
      }
    }
  ]
  return (
    <>
      <Helmet>
        <title> Work Order | ABEPL </title>
      </Helmet>
      {/* {(isLoading) ?
        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
          <img src={loader} alt="loading..." />
        </div>
        : */}
      <Container maxWidth="xl">
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Inspection Work Order
          </Typography>
          {localStorage?.getItem('role') !== QUALITY_ROLES.Inspector &&
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
              <Button component={RouterLink} to={`addinspectionwork`} variant="contained" startIcon={<AddIcon />}>
                ADD
              </Button>
            </Stack>
          }
        </Stack>
        <Box sx={{ height: 450, width: '100%' }}>
          <DataGrid
            rows={localStorage?.role == QUALITY_ROLES.Inspector ? allinspectionworklist?.filter(item => item?.inspectorEmail === loggedInEmail) : allinspectionworklist}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            getRowId={(row) => row?.inspectionOrderId}
            components={{ Toolbar: QuickSearchToolbar }}
          />
        </Box>
      </Container>
      {/* } */}
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }} >
        <MenuItem onClick={() => { navigate(`editinspectionwork/${openId}`) }}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>
        {
          inspectionAssignDetails?.inspectorpresent === 'no' ? <MenuItem onClick={(e) => { assignInspection(e) }}>
            <Iconify icon={'clarity:assign-user-solid'} sx={{ mr: 2 }} />
            Assign
          </MenuItem>
            :
            <></>
        }

        {/* <MenuItem onClick={(e) => { closeInspection(e) }}>
          <Iconify icon={'eva:checkmark-circle-2-fill'} sx={{ mr: 2 }} />
          Close
        </MenuItem> */}
      </Popover>
      {/* ............................Popover for Assign method......................................... */}
      <Dialog open={Boolean(openAssign)} onClose={handleCloseMenu} maxWidth="sm" fullWidth>
        <DialogTitle>Assign Inspector</DialogTitle>
        <Box position="absolute" top={0} right={0}>
          <IconButton onClick={handleCloseMenu}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={6}>
              <FormControl>
                <TextField fullWidth
                  disabled
                  variant="filled"
                  label="Inspection order ID"
                  name="inspectDescription"
                  value={inspectionAssignDetails?.orderId}
                  sx={{ paddingRight: '3%' }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl>
                <TextField fullWidth
                  disabled
                  variant="filled"
                  label="Date of Inspection"
                  name="Date of Inspection"
                  value={inspectionAssignDetails?.dateOfInspection}
                  sx={{ paddingRight: '3%' }}
                />
              </FormControl>
            </Grid>
            {inspectionAssignDetails?.locationType ?
              <Grid item xs={12} lg={6}>
                <FormControl>
                  <TextField fullWidth
                    disabled
                    variant="filled"
                    label="Inspection Location Type"
                    name="Inspection Location Type"
                    value={inspectionAssignDetails?.locationType}
                    sx={{ paddingRight: '3%' }}
                  />
                </FormControl>
              </Grid>
              :
              <></>
            }
            {inspectionAssignDetails?.storageLocation ?
              <Grid item xs={12} lg={6}>
                <FormControl>
                  <TextField fullWidth
                    disabled
                    variant="filled"
                    label="Storage location"
                    name="Storage location"
                    value={inspectionAssignDetails?.storageLocation}
                    sx={{ paddingRight: '3%' }}
                  />
                </FormControl>
              </Grid>
              :
              <></>
            }
            <Grid item xs={12} lg={6}>
              <FormControl>
                <TextField fullWidth
                  disabled
                  variant="filled"
                  label="Status"
                  name="Status"
                  value={inspectionAssignDetails?.status}
                  sx={{ paddingRight: '3%' }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl>
                <InputLabel id="select-qua-param-label">Inspector</InputLabel>
                <Select
                  label="Inspector"
                  onChange={(e) => handleChange(e)}
                  sx={{ minWidth: 210 }}
                >
                  <MenuItem>
                    <em>Select</em>
                  </MenuItem>
                  {
                    inspectorDetails?.map((inspectorlist) =>
                      <MenuItem value={inspectorlist?.firstname + '*' + inspectorlist?.emailAddress + '*' + inspectorlist?.mobileNo}>{inspectorlist?.firstname}</MenuItem>
                    )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleCloseMenu}>
            Cancel
          </Button>
          <Button variant="contained" onClick={() => {
            onSubmitEditInspection();
            handleCloseMenu();
            ;
          }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </>
  )
}

export default WorkInspectionOrder